<template>
<div>
  <section class="section_logo-bar">
    <div class="logonav_wrap">
      <div class="logonav_div">
        <a href="#" class="link-block-73 w-inline-block"><img loading="lazy" src="@/assets/images/OhMyMeds_Logo.svg" alt="" class="image-487"></a>
      </div>
    </div>
  </section>
  <section class="checkout-section">
    <div class="checkoutb_wrap-4">
      <div class="checkoutb_div">
        <div class="almostdone-div">
          <div class="text-block-1151">Almost Done {{user.first_name}}!</div>
          <div class="text-block-1152">Our 100% digital process will ensure you can start your medical weightloss journey in as little as 2 Days.</div>
          <div class="timeline-div">
            <div class="linebullet_div"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-407">
              <div>
                <div class="text-block-1153"><strong class="bold-text-32">5-10 minutes</strong></div>
                <div class="text-block-1154">Complete Medical Questionnaire</div>
                <div class="text-block-1155">Fill out a short online form to submit to the doctor.</div>
              </div>
            </div><img src="@/assets/images/icon_arrowdown.svg" loading="lazy" alt="" class="image-584">
            <div class="linebullet_div"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-407">
              <div>
                <div class="text-block-1153"><strong>24 Hours or Less</strong></div>
                <div class="text-block-1154">Doctor Review &amp; Prescription</div>
                <div class="text-block-1155">Most patients do not require a video doctor visit. If approved you will receive an instant notification.</div>
              </div>
            </div><img src="@/assets/images/icon_arrowdown.svg" loading="lazy" alt="" class="image-584">
            <div class="linebullet_div"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-407">
              <div>
                <div class="text-block-1153"><strong>Same Day Processing</strong></div>
                <div class="text-block-1154">Our Pharmacy Processes Your Order</div>
                <div class="text-block-1155">Our US Based, FDA Approved Pharmacies process your order same day if before 3 (Mon-Thursday)</div>
              </div>
            </div><img src="@/assets/images/icon_arrowdown.svg" loading="lazy" alt="" class="image-584">
            <div class="linebullet_div"><img loading="lazy" src="@/assets/images/icon_circle-icon.svg" alt="" class="image-407">
              <div>
                <div class="text-block-1153"><strong>48 Hours or Less</strong></div>
                <div class="text-block-1154">FREE Overnight Shipping</div>
                <div class="text-block-1155">You can track the packages and get updates directly in our portal.</div>
              </div>
            </div>
          </div>
          <div class="almost-button-div">
            <a href="#" @click="pushToMedForm()" class="button-137 w-button">Complete Medical Form <span class="text-span-330">-&gt;</span></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>
<script>
    
import { mapGetters } from 'vuex';
export default {
    name: 'paymentThanks',
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            active_el: 1,
            selectedOption:'',
            submitting: false,
        }
    },
    computed:{
        ...mapGetters(['getRemainingPrescriptions','user']),
        remainingPrescriptions() {
            return this.getRemainingPrescriptions;
        },
        getDrugName(){
            return this.selectedOption === '' ? 'GLP Anti-Nausea and GLP Energy' : this.selectedOption === 'B12' ? 'GLP Anti-Nausea' : 'GLP Energy'
        },
        getProductName(){
            return JSON.parse(localStorage.getItem("planName"))
        }
    },
    watch: {
        active_el() {
            window.scrollTo(0, 0)
        }
    },
    methods:{
     
        setMedSelected(value){
            this.selectedOption = value;
            this.moveToNext();
        },
        moveToNext(){
            this.active_el=2;
        },
        async sendRequest(product){
          let response = await this.$axios.post(`${this.baseUrl}/api/bundle-selected`, {
              selectedMed: product
          });
          return response;
        },
        async addBundleAndMove(){
            this.submitting = true;
            if(this.selectedOption!=''){
                let response = await this.sendRequest(this.selectedOption);
                console.log(response)
                this.active_el=3;
            }else{
              let response = await this.sendRequest("None");
              console.log(response)
              this.active_el=3;
            }
            
        },
        pushToMedForm(){
          this.$router.push({
                    name: 'verifyPhoneAndEmail'
          });
        }
    },
    mounted(){
        console.log(this.remainingPrescriptions)
        
    }
}
</script>